module.exports = __webpack_public_path__ + "static/media/tars-loyalty-icon.f6066fbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tars-loyalty-icon.svg
// module id = 620
// module chunks = 0